var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, Children } from 'react';
import styled, { css } from 'styled-components';
const TableStyle = styled.table `
  line-height: ${props => props.theme.fonts.lineHeight};
  font-family: ${props => props.theme.fonts.fontFamily};
  width: 100%;
  display: table;
  border-spacing: 0;
  border-collapse: ${(props) => (props.stickyHeader ? 'separate' : 'collapse')};
  ${(props) => props.highContrast &&
    css `
      & tr:nth-child(even) {
        background: ${props.theme.utils.getColorLight('grey')};
      };
    `};
  ${(props) => props.isDense &&
    css `
      & * {
        padding-top: 0;
        padding-bottom: 0;
      }
    `};
`;
const Table = (_a) => {
    var { highContrast = false, stickyHeader = false, isDense = false, children } = _a, props = __rest(_a, ["highContrast", "stickyHeader", "isDense", "children"]);
    const cloneElementData = function (element) {
        return cloneElement(element, { stickyHeader });
    };
    const elements = Children.map(children, cloneElementData);
    return (_jsx(TableStyle, Object.assign({ isDense: isDense, stickyHeader: stickyHeader, highContrast: highContrast }, props, { children: stickyHeader ? elements : children })));
};
export default Table;
